import { AdminUpdateUserRequestDTO } from '../types/dtos/admin-update-user.dto';
import { isPhoneNumberIncomplete } from '../../shared/components/Forms/PhoneNumberField.component';
import { isValidEmail } from '../../shared/utils/is-valid-email.util';

export type UserFieldErrors = {
  firstname?: string;
  lastname?: string;
  email?: string;
  phoneNumber?: string;
  ecoPoints?: string;
};

export const FIRSTNAME_REQUIRED_ERROR = 'Veuillez saisir un prénom';

export const LASTNAME_REQUIRED_ERROR = 'Veuillez saisir un nom';

export const EMAIL_INVALID_ERROR = "L'adresse mail n'est pas valide";

export const PHONE_NUMBER_REQUIRED_ERROR = 'Veuillez saisir un numéro de téléphone';

export const PHONE_NUMBER_LENGTH_ERROR = 'Le numéro doit comporter dix chiffres';

export const ECO_POINTS_ERROR = 'Positif ou nul, deux décimales au plus';

const ECO_POINTS_PATTERN = /^\d+(\.\d{1,2})?$/;

export const isEcoPointsValid = (points: string): boolean => ECO_POINTS_PATTERN.test(points);

const getPhoneNumberError = (phoneNumber: string): string | undefined => {
  if (phoneNumber.length === 0) return PHONE_NUMBER_REQUIRED_ERROR;
  return isPhoneNumberIncomplete(phoneNumber) ? PHONE_NUMBER_LENGTH_ERROR : undefined;
};

export const getUserFieldErrors = ({
  firstname,
  lastname,
  email,
  phoneNumber,
  ecoPoints,
}: AdminUpdateUserRequestDTO): UserFieldErrors => {
  const phoneNumberError = phoneNumber === undefined ? undefined : getPhoneNumberError(phoneNumber);

  return {
    ...(firstname !== undefined && !firstname.trim() ? { firstname: FIRSTNAME_REQUIRED_ERROR } : {}),
    ...(lastname !== undefined && !lastname.trim() ? { lastname: LASTNAME_REQUIRED_ERROR } : {}),
    ...(email !== undefined && !isValidEmail(email) ? { email: EMAIL_INVALID_ERROR } : {}),
    ...(phoneNumberError ? { phoneNumber: phoneNumberError } : {}),
    ...(ecoPoints !== undefined && !isEcoPointsValid(String(ecoPoints)) ? { ecoPoints: ECO_POINTS_ERROR } : {}),
  };
};
